import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";

@Component({
  moduleId: module.id,
  selector: 'site-listNewsPage',
  templateUrl: './listNewsPage.component.html',
  styleUrls: ['./listNewsPage.component.css']
})
export class ListNewsPage {

  constructor(private contentService:ContentService)
  {
  }

  newsArticleList: ContentModel;
  
  ngOnInit(): void{
    this.getNewsArticleList().subscribe(w =>{
      this.newsArticleList = w;
    })
  }

  private getNewsArticleList(): Observable<ContentModel>
  {
    return this.contentService.getContentList("News Article").map((v,i)=>v);
  }

}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/listNewsPage/listNewsPage.component.ts